import { PROFILE_INFO_NOTES_FIELD_NAME } from '../ProfileInfoWidget.constants'
import { getInfoWidgetReadFields } from '../ProfileInfoWidget.utils'
import { ProfileInfoWidgetItem } from '../ProfileInfoWidgetItem'
import { ProfileInfoWidgetNotes } from '../ProfileInfoWidgetNotes'

function isCollapsibleField({ isCollapsible }) {
  return isCollapsible
}

function isVisibleField({ isCollapsible }) {
  return !isCollapsible
}

function toFieldRow({ label, name, placeholder, type, value, onClickEmail }) {
  return {
    key: name,
    node: (
      <ProfileInfoWidgetItem
        label={label}
        placeholder={placeholder}
        type={type}
        value={value}
        onClickEmail={onClickEmail}
      />
    ),
  }
}

export function getInfoWidgetReadRows({ config, data, t, onClickEmail }) {
  const fields = getInfoWidgetReadFields({ config, data, t }).map(field => ({
    ...field,
    onClickEmail,
  }))

  const notesRow = data?.notes
    ? {
        key: PROFILE_INFO_NOTES_FIELD_NAME,
        node: <ProfileInfoWidgetNotes notes={data.notes} />,
      }
    : null

  const baseRows = (notesRow ? [notesRow] : []).concat(
    fields.filter(isVisibleField).map(toFieldRow)
  )

  const extraRows = fields.filter(isCollapsibleField).map(toFieldRow)

  return { baseRows, extraRows }
}
